<template>
  <!-- 管理员登录页面 -->
  <div class="login-wrapper" style="background-image: url(../../static/img/bg.png)">
    <div class="login-card">
      <!-- 标题 -->
      <div class="login-card__title">云伴展管理平台</div>
      <!-- 登录表单 -->
      <el-form :model="loginForm" ref="loginForm" :rules="rules" status-icon>
        <el-form-item label="登录账号" prop="username" class="form-label">
          <el-input v-model="loginForm.username" placeholder="请输入账号" prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password" class="form-label">
          <el-input v-model="loginForm.password" placeholder="请输入密码" prefix-icon="el-icon-lock" show-password></el-input>
        </el-form-item>
        <el-form-item class="form-submit" v-loading="loading">
          <el-button type="primary" @click="loginform('loginForm')">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "adminLogin",
  data() {
    /** 账号校验：不能为空 */
    let validateCheckUsername = (rule, value, callback) => {
      setTimeout(() => {
        if (!value) {
          return callback(new Error('账号不能为空'))
        } else {
          callback();
        }
      }, 500)
    };

    /** 密码校验：5-16位数字或字母 */
    let validateCheckPassword = (rule, value, callback) => {
      let reg = /^[0-9A-Za-z]{5,16}$/;
      setTimeout(() => {
        if (!value) {
          return callback(new Error('密码不能为空'))
        } else {
          if (!reg.test(value)) {
            callback(new Error("密码必须由5-16位数字或字母组成"))
          } else {
            callback();
          }
        }
      }, 500)
    };

    return {
      /** 登录加载状态 */
      loading: false,
      /** 登录表单数据 */
      loginForm: {
        username: "",
        password: "",
      },
      /** 表单校验规则 */
      rules: {
        username: [{ validator: validateCheckUsername, trigger: 'blur' }],
        password: [{ validator: validateCheckPassword, trigger: 'blur' }]
      },
    }
  },

  methods: {
    /**
     * 管理员登录
     * 1. 校验表单
     * 2. 调用登录接口获取 Token
     * 3. 验证是否为管理员
     * 4. 存储 Token 并跳转到管理后台首页
     * @param {string} formname - 表单 ref 名称
     */
    loginform(formname) {
      this.$refs[formname].validate((valid) => {
        this.loading = true;
        if (valid) {
          let username = this.loginForm.username;
          let password = this.loginForm.password;
          let url = this.baseUrl + '/admin/login/';
          let checkUrl = this.baseUrl + '/admin/check_admin/';

          this.$http.post(url, { username: username, password: password }, { emulateJSON: true }).then(res => {
            if (res.status === 200) {
              this.loading = false;
              let id = res.data.user.id;
              let name = res.data.user.name;
              let token = res.data.token;
              let is_superuser = res.data.user.is_superuser;

              /** 验证管理员权限 */
              this.$http.post(checkUrl, {}, {
                headers: { "Authorization": "JWT " + token }
              }).then(res => {
                if (res.body.isAdmin) {
                  localStorage.setItem("adminToken", token);
                  localStorage.setItem("id", id);
                  localStorage.setItem("name", name);
                  localStorage.setItem('is_superuser', is_superuser);
                  this.$router.push({ name: 'admin_index' });
                } else {
                  this.$message({ message: '请检查你的账号或密码', type: 'warning' });
                }
              }).catch(() => {
                this.$message({ message: "权限验证失败，请稍后重试", type: 'error' });
              })
            }
          }).catch(err => {
            this.loading = false;
            if (err.status === 400) {
              this.$message({ message: "请检查你的账号或密码", type: 'warning' });
            } else {
              this.$message({ message: "网络异常，无法连接服务器", type: 'error' });
            }
          })
        } else {
          this.loading = false;
        }
      })
    },
  },
}
</script>

<style scoped>
.form-label {
  margin-top: 20px;
  font-weight: bold;
  font-size: 18px;
}

.form-submit {
  margin-top: 40px;
}

.form-submit .el-button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/adminLogin.vue